import {sendGet, sendPost} from './axiosClients'
export const getListTreeUser = (data) => sendGet('/user/tree', data);
export const getCurrentTreeUser = (id, data) => sendGet(`/user/tree/${id}`, data);
export const getListUser = (data) => sendGet('/user/account/list', data);
export const getUserAnalyst = (data) => sendGet('/user/analystic', data);
export const sendUserEmail = (data) => sendPost('/user/email',data)
export const createUser = (data) => sendPost('/user/account/create', data);
export const updateAvatar = (data) => sendPost('/user/account/avatar', data);
export const getUserAnalystPeriod = (data) => sendGet('/user/analystic/period',data);